import { api } from "../../plugins/api"
import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const state = {
  citoyennete: [],
  motifsRenonciation: [],
  paysDeNaissance: [],
  provinces: [],
  pays: [],
  sexes: [],
  genres: [],
  titresDePreference: [],
  pni: [],
  nationsInuit: [],
  decisionDisciplinaireDUnAutreOrdreProfessionnel: [],
  decisionDisciplinaireDUnOrganismeDeLExterieurDuQuebec: [],
  decisionDUnTribunalCanadienOuEtranger: [],
  decisionRendueAuQuebec: [],
  poursuitePourUneInfractionPunissableDe5AnsOuPlusDEmprisonnement: [],
  categorieAutorisation: [],
  autorisationAutorisationDePratiques: [],
  categorieFormation: [],
  langue: [],
  niveauLangue: [],
  autresOrdres: [],
  instancesReglementaires: [],
  pratiqueActivite: [],
  statutCompletion: [],
  activitesReservees: [],
  contributions: [],
  decisionDisciplinaireAutreOrdre: [],
  decisionDisciplinaireOrganisme: [],
  decisionTribunalCanadienOuEtranger: [],
  decisionRenduAuQuebec: [],
  poursuiteInfractionsPunissables: [],
  communicationsTiers: [],
  communicationsRevueIntervention: [],
  communicationsStatistiques: [],
  typesMandatsBottin: [],
  raisons: [],
  origineAdmission: [],
  statutAdmission: [],
  nbHeureTravailleEnPratiqueAutonomne: [],
  installationHandicape: [],
  fonctions: [],
  domainesDePratique: [],
  typeClient: [],
  methodesDIntervention: [],
  approchesDIntervention: [],
  servicesOfferts: [],
  type: [],
  statutAutorisationDePratiques: [],
  statutsEmploi: [],
  precisionsStatut: [],
  contributionsVolontaires: [],
  assurances: [],
  nombreDePaiements: [],
  problemesSociauxGeneraux: [],
  therapieTechniquesDIntervention: [],
  expertiseLegalesActivitesReservees: [],
  modesDeReglement: [],
  serviceDeReferenceEnLigne: [],
  activiteAdoptionHorsQuebec: [],
  demandeAdmissionJeConfirmeEtreALEmploiDe: [],
  scolariteType: [],
  reclamationsAssurances: [],
  telepratiqueChoix: [],
  telepratiqueAuQuebec: [],
  raisonsDuRetrait: [],
  reinscriptionsPrevues: [],
}

const getters = {
  GET_CITOYENNETE: (state) => {
    return state.citoyennete
  },
  GET_PAYSDENAISSANCE: (state) => {
    return state.paysDeNaissance
  },
  GET_PROVINCES: (state) => {
    return state.provinces
  },
  GET_PAYS: (state) => {
    return state.pays
  },
  GET_SEXE: (state) => {
    return state.sexes
  },
  getGenre: (state) => {
    return state.genres
  },
  getTitresDePreference: (state) => {
    return state.titresDePreference
  },
  getPni: (state) => {
    return state.pni
  },
  getNationsInuit: (state) => {
    return state.nationsInuit
  },
  GET_CATALOGUES: (state) => {
    return state
  },
  GET_CATEGORIEAUTORISATION: (state) => {
    return state.categorieAutorisation
  },
  GET_AUTORISATIONS: (state) => {
    return state.autorisationAutorisationDePratiques
  },
  GET_AUTORISATIONS_BY_CATEGORIEAUTORISATION: (state) => (categorieId) => {
    return state.autorisationAutorisationDePratiques.filter((a) => a.parent == categorieId)
  },
  GET_CATEGORIEFORMATION: (state) => {
    return state.categorieFormation
  },
  GET_LANGUE: (state) => {
    return state.langue
  },
  GET_NIVEAULANGUE: (state) => {
    return state.niveauLangue
  },
  GET_AUTRESORDRE: (state) => {
    return state.autresOrdres
  },
  GET_INSTANCESREGLEMENTAIRES: (state) => {
    return state.instancesReglementaires
  },
  GET_PRATIQUE_ACTIVITE: (state) => {
    return state.pratiqueActivite
  },
  GET_STATUT_COMPLETION: (state) => {
    return state.statutCompletion
  },
  GET_ACTIVITES_RESERVEES: (state) => {
    return state.activitesReservees
  },
  GET_CONTRIBUTIONS: (state) => {
    return state.contributions
  },
  GET_DECISIONDISCIPLINAIREAUTREORDRE: (state) => {
    return state.decisionDisciplinaireAutreOrdre
  },
  //GET_DECISIONDISCIPLINAIREORGANISME: (state) => { return state.decisionDisciplinaireOrganisme }, // alias de decisionDisciplinaireAutreOrdre
  GET_DECISIONTRIBUNALCANADIENOUETRANGER: (state) => {
    return state.decisionTribunalCanadienOuEtranger
  },
  GET_DECISIONRENDUAUQUERBEC: (state) => {
    return state.decisionRenduAuQuebec
  },
  GET_POURSUITEINFRACTIONPUNISSABLES: (state) => {
    return state.poursuiteInfractionsPunissables
  },
  GET_COMMUNICATIONSTIERS: (state) => {
    return state.communicationsTiers
  },
  GET_COMMUNICATIONSREVUEINTERVENTION: (state) => {
    return state.communicationsRevueIntervention
  },
  GET_COMMUNICATIONSSTATISTIQUES: (state) => {
    return state.communicationsStatistiques
  },
  GET_TYPESMANDATSBOTTIN: (state) => {
    return state.typesMandatsBottin
  },
  GET_RAISONS: (state) => {
    return state.raisons
  },
  GET_ORIGINEADMISSION: (state) => {
    return state.origineAdmission
  },
  GET_STATUTADMISSION: (state) => {
    return state.statutAdmission
  },
  GET_NBHEUREPRATIQUEAUTONOMNE: (state) => {
    return state.nbHeureTravailleEnPratiqueAutonomne
  },
  GET_INSTALATIONHANDICAPE: (state) => {
    return state.installationHandicape
  },
  GET_FONCTIONS: (state) => {
    return state.fonctions
  },
  GET_DOMAINESDEPRATIQUE: (state) => {
    return state.domainesDePratique
  },
  GET_TYPECLIENT: (state) => {
    return state.typeClient
  },
  GET_METHODESDINTERVENTION: (state) => {
    return state.methodesDIntervention
  },
  GET_APPROCHESDINTERVENTION: (state) => {
    return state.approchesDIntervention
  },
  GET_SERVICESOFFERTS: (state) => {
    return state.servicesOfferts
  },
  GET_TYPE: (state) => {
    return state.type
  },
  GET_STATUTAUTORISATIONDEPRATIQUE: (state) => {
    return state.statutAutorisationDePratiques
  },
  getStatutsEmploi: (state) => {
    return state.statutsEmploi
  },
  getPrecisionsStatut: (state) => {
    return state.precisionsStatut
  },
  getContributionsVolontaires: (state) => {
    return state.contributionsVolontaires
  },
  getAssurances: (state) => {
    return state.assurances
  },
  getNombreDePaiements: (state) => {
    return state.nombreDePaiements
  },
  getProblemesSociauxGeneraux: (state) => {
    return state.problemesSociauxGeneraux
  },
  getTherapieTechniquesDIntervention: (state) => {
    return state.therapieTechniquesDIntervention
  },
  getExpertiseLegalesActivitesReservees: (state) => {
    return state.expertiseLegalesActivitesReservees
  },
  getModesDeReglement: (state) => {
    return state.modesDeReglement
  },
  getServicesDeReferenceEnLigne: (state) => {
    return state.serviceDeReferenceEnLigne
  },
  getActiviteAdoptionHorsQuebec: (state) => {
    return state.activiteAdoptionHorsQuebec
  },
  getMotifsRenonciation: (state) => {
    return state.motifsRenonciation
  },
  getDemandeAdmissionJeConfirmeEtreALEmploiDe: (state) => {
    return state.demandeAdmissionJeConfirmeEtreALEmploiDe
  },
  getScolariteType: (state) => {
    return state.scolariteType
  },
  getReclamationsAssurances: (state) => {
    return state.reclamationsAssurances
  },
  getTelepratiqueChoix: (state) => {
    return state.telepratiqueChoix
  },
  getTelepratiqueAuQuebec: (state) => {
    return state.telepratiqueAuQuebec
  },
  getRaisonsDuRetrait: (state) => {
    return state.raisonsDuRetrait
  },
  getReinscriptionsPrevues: (state) => {
    return state.reinscriptionsPrevues
  },
}

const mutations = {
  // Citoyenneté
  SET_1546(state, values) {
    state.citoyennete = values
  },
  // Motif(s) renonciation
  SET_1561(state, values) {
    state.motifsRenonciation = values
  },
  // Pays de naissance
  SET_1514(state, values) {
    state.paysDeNaissance = values
  },
  // Provinces
  SET_313(state, values) {
    state.provinces = values
  },
  // Origine admission
  SET_1505(state, values) {
    state.origineAdmission = values
  },
  // Statut admission
  SET_1510(state, values) {
    state.statutAdmission = values
  },
  // Pays
  SET_303(state, values) {
    state.pays = values
  },
  // Sexe
  SET_1513(state, values) {
    state.sexes = values
  },
  // Genre
  SET_265(state, values) {
    state.genres = values
  },
  // Titre de preferences
  SET_223(state, values) {
    state.titresDePreference = values
  },
  // PNI
  SET_224(state, values) {
    state.pni = values
  },
  // Nations/Inuit
  SET_258(state, values) {
    state.nationsInuit = values
  },
  // Categorie Formation
  SET_1526(state, values) {
    state.categorieFormation = values.sort(function (a, b) {
      return ("" + b.lang00).localeCompare(a.lang00)
    })
  },
  // Categorie Autorisation De Pratique
  SET_11122(state, values) {
    state.categorieAutorisation = values
  },
  // Categorie Niveau Langue
  SET_1908(state, values) {
    state.niveauLangue = values
  },
  // Categorie Langues
  SET_1901(state, values) {
    let temp = values.sort(function (a, b) {
      return ("" + a.lang00).localeCompare(b.lang00)
    })

    temp = temp.sort(function (a, b) {
      let value = a.code ? a.code : 9999
      let value2 = b.code ? b.code : 9999
      return ("" + value).localeCompare(value2, { numeric: true })
    })

    state.langue = temp
  },
  // Categorie MembreAutresOrdres
  SET_2601(state, values) {
    state.autresOrdres = values
  },
  // Categorie Instances reglementaires
  SET_2603(state, values) {
    state.instancesReglementaires = values
  },
  // Pratique activité 3.6.10
  SET_6803(state, values) {
    state.pratiqueActivite = values
  },
  // Statut complétion
  SET_6804(state, values) {
    state.statutCompletion = values.sort(function (a, b) {
      const value = a.code ? a.code : 9999
      const value2 = b.code ? b.code : 9999
      return ("" + value).localeCompare(value2, { numeric: true })
    })
  },
  // Activités réservées
  SET_6806(state, values) {
    state.activitesReservees = values
  },
  // TransmissionOrdre.Contribution
  SET_3028(state, values) {
    state.contributions = values
  },
  // Categorie DecisionDisciplinaireAutreOrdre
  SET_2103(state, values) {
    state.decisionDisciplinaireAutreOrdre = values
  },
  // Categorie DecisionDisciplinaireOrganisme
  SET_2104(state, values) {
    state.decisionDisciplinaireOrganisme = values
  },
  // Categorie DecisionTribunalCanadienOuEtranger
  SET_2115(state, values) {
    state.decisionTribunalCanadienOuEtranger = values
  },
  // Categorie DecisionRenduAuQuebec
  SET_2116(state, values) {
    state.decisionRenduAuQuebec = values
  },
  // Categorie PoursuiteInfractionsPunissables
  SET_2123(state, values) {
    state.poursuiteInfractionsPunissables = values
  },
  // Categorie CommunicationsTiers
  SET_3004(state, values) {
    state.communicationsTiers = values
  },
  // Categorie CommunicationsRevueIntervention
  SET_3029(state, values) {
    state.communicationsRevueIntervention = values
  },
  // Categorie CommunicationsStatistiques
  SET_3005(state, values) {
    state.communicationsStatistiques = values
  },
  // Categorie CommunicationsMandatsBottins
  SET_3010(state, values) {
    state.typesMandatsBottin = values
  },
  // Categorie Raison
  SET_3007(state, values) {
    state.raisons = values
  },
  // Nombre d'heure travaille en pratique autonomne
  SET_424(state, values) {
    state.nbHeureTravailleEnPratiqueAutonomne = values
  },
  // Installation aux handicapes
  SET_425(state, values) {
    state.installationHandicape = values
  },
  // Fonction
  SET_413(state, values) {
    state.fonctions = values
  },
  // Domaines de pratique
  SET_426(state, values) {
    state.domainesDePratique = values
  },
  // Type de client
  SET_427(state, values) {
    state.typeClient = values
  },
  // Méthodes d'intervention
  SET_428(state, values) {
    state.methodesDIntervention = values
  },
  // Approche d'intervention
  SET_429(state, values) {
    state.approchesDIntervention = values
  },
  // Services offerts
  SET_431(state, values) {
    state.servicesOfferts = values
  },
  // Document.Type
  SET_11011(state, values) {
    state.type = values
  },
  SET_2310(state, values) {
    state.statutAutorisationDePratiques = values
  },
  SET_2311(state, values) {
    state.autorisationAutorisationDePratiques = values
  },
  SET_2904(state, values) {
    state.statutsEmploi = values
  },
  SET_2910(state, values) {
    state.contributionsVolontaires = values
  },
  SET_2902(state, values) {
    state.assurances = values
  },
  SET_2906(state, values) {
    state.precisionsStatut = values
  },
  SET_2929(state, values) {
    state.nombreDePaiements = values
  },
  SET_454(state, values) {
    state.problemesSociauxGeneraux = values
  },
  SET_452(state, values) {
    state.therapieTechniquesDIntervention = values
  },
  SET_453(state, values) {
    state.expertiseLegalesActivitesReservees = values
  },
  SET_2928(state, values) {
    state.modesDeReglement = values
  },
  SET_458(state, values) {
    state.serviceDeReferenceEnLigne = values
  },
  // Activités réservées
  SET_6807(state, values) {
    state.activiteAdoptionHorsQuebec = values
  },
  SET_1564(state, values) {
    state.demandeAdmissionJeConfirmeEtreALEmploiDe = values
  },
  // Scolarite - type
  SET_31802(state, values) {
    state.scolariteType = values
  },
  // Declaration Obligatoire - reclamations assurances
  SET_2137(state, values) {
    state.reclamationsAssurances = values
  },
  // Telepratique - choix
  SET_32504(state, values) {
    state.telepratiqueChoix = values
  },
  // Telepratique - telepratique au Quebec
  SET_32505(state, values) {
    state.telepratiqueAuQuebec = values
  },
  // Demande d'inscription - Raison du retrait
  SET_2441(state, values) {
    state.raisonsDuRetrait = values
  },
  // Demande d'inscription - Réinscription prévue dans les 5 prochaines années
  SET_2442(state, values) {
    state.reinscriptionsPrevues = values
  },
}

const actions = {
  async getCatalogue({ commit }, descid) {
    const response = await api.get(`catalogues/${descid}`)
    commit(`SET_${descid}`, response.data)
    return response.data
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
}